





















import { Component, Vue } from "vue-property-decorator";
import Video from "@/components/Video.vue";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Video,
    Header,
    Menu,
    NextPrevBtn,
    Footer,
  },
})
export default class CVKeys extends Vue {
  protected videoCVTips = [
    {
      videoSrc: "https://www.youtube.com/embed/ljDuhygWlD4",
      videoTitle: "Méthodologie du CV",
      videoRoot: "Chaîne : digiSchool",
    },
    {
      videoSrc: "https://www.youtube.com/embed/5oHVIuNPtGg",
      videoTitle: "Comment rédiger un CV efficace?",
      videoRoot: "Chaîne :  AXA France",
    },
    {
      videoSrc: "https://www.youtube.com/embed/l1hhhndMzIs",
      videoTitle: "Les règles d’or du CV",
      videoRoot: "Chaîne :  1er emploi, jobs, stages",
    },
    {
      videoSrc: "https://www.youtube.com/embed/xOqgIDRqoeg",
      videoTitle: "Les astuces pour rédiger son CV",
      videoRoot: "Chaîne : TVBilan",
    },
  ];
  protected nxtprevCVTips =
  {
    BoolPrev: true,
    BoolNext: true,
    PrevImage: "/thumbnail7.png",
    NextImage: "/thumbnail2.png",
    PrevLink: "/CV/Fondamentaux",
    NextLink: "/CV/Exemples",
  };
}
